import { FileTypes, Frequency, ViewBy } from '@emi/shared/models';
import { PricePer } from 'libs/shared/models/src/lib/types/price-per.type';

export const Application: {
    DEFAULT_FREQUENCY: Frequency;
    DEFAULT_PRICE_PER: PricePer;
    DEFAULT_FILE_TYPE: FileTypes;
    DEFAULT_VIEW_BY: ViewBy;
    MAX_SELECTABLE_SKUS: { value: number; message: string };
} = {
    DEFAULT_FREQUENCY: 'Monthly',
    DEFAULT_PRICE_PER: 'Sku',
    DEFAULT_FILE_TYPE: 'CSV',
    DEFAULT_VIEW_BY: 'AcrossRetailers',
    MAX_SELECTABLE_SKUS: { value: 1000000, message: 'Total SKU count exceeds 1 million please refine your search criteria.' },
};
